module.exports = __webpack_public_path__ + "img/did_you_know_bg.462dc926.jpg";